import '../themeDefaults';

export default ({ formComponents: theme }) => ({
  checkboxIcon: {
    '&$selected': {
      background: ({ dark }) => (dark
        ? theme.checkboxRadio.dark.selectedColor
        : theme.checkboxRadio.selectedColor),
      borderColor: ({ dark }) => (dark
        ? theme.checkboxRadio.dark.selectedColor
        : theme.checkboxRadio.selectedColor)
    },
    borderRadius: 2,
    display: 'inline-block'
  },
  dash: {
    color: ({ dark }) => (dark
      ? theme.checkboxRadio.dark.borderColor
      : theme.checkboxRadio.borderColor),
    height: 16,
    left: -1,
    linHeight: '16px',
    position: 'absolute',
    textAlign: 'center',
    top: -1,
    width: 16
  },
  icon: {
    '& svg': {
      fill: ({ dark }) => (dark
        ? theme.checkboxRadio.dark.checkColor
        : theme.checkboxRadio.checkColor),
      height: 8,
      left: 3,
      position: 'absolute',
      top: 3,
      width: 8
    },
    background: 'transparent',
    borderColor: ({ dark }) => (dark
      ? theme.checkboxRadio.dark.borderColor
      : theme.checkboxRadio.borderColor),
    borderStyle: 'solid',
    borderWidth: 1,
    display: theme.checkboxRadioSvgDisplay,
    height: 16,
    left: 0,
    marginTop: -9,
    position: 'absolute',
    top: '50%',
    width: 16
  },

  radioDot: {
    background: ({ dark }) => (dark
      ? theme.checkboxRadio.dark.selectedColor
      : theme.checkboxRadio.selectedColor),
    borderRadius: 100,
    display: 'none',
    height: 10,
    left: 2,
    position: 'relative',
    top: 2,
    width: 10
  },
  radioIcon: {
    '&$selected': {
      '& $radioDot': {
        display: 'block'
      },
      borderColor: ({ dark }) => (dark
        ? theme.checkboxRadio.dark.selectedColor
        : theme.checkboxRadio.selectedColor)
    },
    background: 'transparent',
    borderColor: ({ dark }) => (dark
      ? theme.checkboxRadio.dark.borderColor
      : theme.checkboxRadio.borderColor),
    borderRadius: 100
  },
  root: {
    '& input': {
      height: 16,
      left: 0,
      margin: 0,
      marginTop: -9,
      opacity: 0,
      position: 'absolute',
      top: '50%',
      width: 16,
      zIndex: 1
    },
    '& input:focus + $icon': {
      boxShadow: `0 0px 8px ${theme.checkboxRadio.shadowColor}`,
      outline: `${theme.checkboxRadio.selectedColor} solid 1px`
    },
    '& p': {
      margin: 0
    },
    cursor: 'pointer',
    display: ({ inline }) => (!inline ? 'block' : 'inline-block'),
    height: 18,
    lineHeight: '18px',
    marginBottom: 15,
    opacity: ({ disabled }) => disabled && 0.5,
    padding: [0, 0, 0, 26],
    position: 'relative'
  },
  selected: {}
});
